import React from "react";
import PropTypes from "prop-types";
import { clx } from "../../../../utils/Helpers";

const EMPTY_VALUE = "-";

const CompanyOverviewField = ({ label, value, children, valueClassName }) => (
  <div className="company-overview-field">
    <div className="company-overview-field__label">{label}</div>
    <div className={clx("company-overview-field__value", valueClassName)}>
      {children ?? value ?? EMPTY_VALUE}
    </div>
  </div>
);

CompanyOverviewField.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.node,
  children: PropTypes.node,
  valueClassName: PropTypes.string,
};

CompanyOverviewField.defaultProps = {
  value: EMPTY_VALUE,
  children: null,
  valueClassName: "",
};

export default CompanyOverviewField;
